<template>
  <section
    class="add_new_head white--body tx--bege relative cover m_bg_blue no_mobile"
    style="background-image:url('/assets/img/layout/bg_serg.jpg');"
  >
    <div class="popup_close close-animate">
      <a @click="goBackRoute"><CloseSvg /></a>
    </div>
    <a
      v-show="!isEditMode || (isEditMode && currentStep !== 2)"
      class="no_mobile link_goback"
      @click="onPrevStage"
    >
      חזרה <ArrowBack />
    </a>
    <div class="inner_width flex flex--column center">
      <h1 class="title">
        <span class="bold">
          {{ isEditMode ? "עריכת" : "יצירת" }} ניתוח לשיבוץ -</span
        >{{ activeDoctor.name }}
      </h1>
      <Steps />
    </div>
  </section>
</template>

<script>
import ArrowBack from "@/assets/img/svg/arrow_r.svg";
import CloseSvg from "@/assets/img/svg/close.svg";
import Steps from "@/components/Dashboard/Surgery/AddSurgery/Layout/Steps.vue";
import { getHash } from "@/utilities/hash.js";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  components: { ArrowBack, CloseSvg, Steps },
  computed: {
    ...mapState("Surgery", ["isEditMode", "currentStep"]),
    ...mapGetters(["activeDoctor"])
  },
  methods: {
    ...mapMutations("Surgery", ["SET_CURRENT_STEP"]),
    /**
     * Navigate back to surgeries list with hash preserved
     */
    goBackRoute() {
      const hashData = JSON.parse(localStorage.getItem("hashData"));
      if (!hashData || !Object.keys(hashData).length) {
        return this.$router.push("/dashboard/surgeries");
      }
      const hash = getHash({});
      return this.$router.push("/dashboard/surgeries#" + hash);
    },
    /**
     * Handle step navigation back
     */
    async onPrevStage() {
      if (this.currentStep === 2) {
        this.SET_CURRENT_STEP(1);
        this.$router.push({ name: "surg-add" });
      } else if (this.currentStep > 2) {
        if (this.currentStep === 3) {
          await this.$parent.$refs.surgeryDetails?.addBlockDefaults();
        }
        this.SET_CURRENT_STEP(this.currentStep - 1);
      }
    }
  }
};
</script>
